var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"align-center":"","column":"","fill-height":"","id":"mlc-0900","justify-center":""}},[_c('img',{staticClass:"d-block mx-auto",staticStyle:{"width":"20%","margin-bottom":"2.5rem"},attrs:{"src":_vm.iconMaintenance,"alt":""}}),_c('div',{staticClass:"font-20 font-weight-bold mb-0",domProps:{"innerHTML":_vm._s(
      _vm.getContentByCurrentLanguage(_vm.$store.getters['system/properties'].maintenance.message)
    )}})])
}
var staticRenderFns = []

export { render, staticRenderFns }